export const createDefaultPaymentContextValue = (defaultValue: any | undefined = undefined) => defaultValue;

export default createDefaultPaymentContextValue;
